import React from "react"
import { Drawer, CircularProgress, FloatingActionButton, Toggle } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IClientContactDocument } from "../../../models"
import * as api from "../../../api"
import AppStateStore from "../../../stores/AppStateStore"
import TableActionBar from "../../../components/layout/TableActionBar"
import ClientContactTable from "./client-contact-details/ClientContactTable"
import AddClientContactDialog from "./client-contact-details/AddClientContactDialog"
import EditClientContactForm from "./client-contact-details/EditClientContactForm"
interface IProps {
    readonly: boolean
    clientId: string
    reloadClient(): void
}
interface IState {
    clientContacts: IClientContactDocument[]
    clientId: string
    active: boolean
    selectedClientContacts: IClientContactDocument[]
    selectedContactForEdit: IClientContactDocument
    searchText: string
    loading: boolean
    total: number
    offset: number
    limit: number
    openAddClientContactDialog: boolean
    openEditClientContactDrawer: boolean
}

export default class ClientContacts extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            clientContacts: [],
            clientId: props.clientId,
            active: true,
            selectedClientContacts: [],
            selectedContactForEdit: undefined,
            searchText: "",
            loading: false,
            total: 0,
            offset: 0,
            limit: 20,
            openAddClientContactDialog: false,
            openEditClientContactDrawer: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getClientContacts(this.state.clientId, this.state.active)
    }

    reloadClientContactTable() {
        this.getClientContacts(this.state.clientId, this.state.active)
    }

    getClientContacts(clientId: string, active: boolean) {
        this.setState({ loading: true }, () => {
            api.getClientContacts(clientId, active)
                .then(res => {
                    this.setState({
                        loading: false,
                        clientContacts: res.data,
                        searchText: "",
                        selectedClientContacts: [],
                        offset: 0
                    })
                })
        })
    }

    handleDelete() {
        AppStateStore.setProgressSnackbarContent("loading")
        api.deleteClientContact({ data: this.state.selectedClientContacts.map(contact => contact.Id) }).then(() => {
            this.setState({ selectedClientContacts: [] })
            AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
            this.getClientContacts(this.state.clientId, this.state.active),
                this.props.reloadClient()
        })
    }

    handleUpdateClientContact(clientContact: IClientContactDocument, imageData: string | boolean) {
        api.updateClientContact(clientContact).then(() => {
            if (imageData !== null && imageData !== false) {
                api.uploadClientContactProfilePicture(clientContact.Id, imageData).then(() => {
                    this.getClientContacts(this.state.clientId, this.state.active)
                    this.props.reloadClient()
                })
            } else if (imageData === false) {  // False means remove the picture
                api.removeClientContactProfilePicture(clientContact.Id).then(() => {
                    this.getClientContacts(this.state.clientId, this.state.active)
                    this.props.reloadClient()
                })
            } else {
                this.getClientContacts(this.state.clientId, this.state.active)
                this.props.reloadClient()
            }
        }).finally(() => {
            this.setState({ openEditClientContactDrawer: false, selectedContactForEdit: undefined })
        })
    }

    render() {
        const searchText = this.state.searchText.toLowerCase()
        const filteredContacts = this.state.clientContacts.filter(item => item.FirstName.toLowerCase().indexOf(searchText) > -1 || item.LastName.toLowerCase().indexOf(searchText) > -1)
        const viewableContacts = filteredContacts.slice(this.state.offset, Math.min(this.state.offset + this.state.limit, filteredContacts.length))
        return (
            <div className="detail-tab">
                <div style={{ position: "relative" }}>
                    {this.state.loading ?
                        <div className="spinner">
                            <CircularProgress />
                        </div> :
                        <div>
                            {!this.props.readonly &&
                                <FloatingActionButton
                                    className="fixed-add"
                                    style={{ position: "relative", float: "right", right: 50, top: -45, zIndex: 998 }}
                                    secondary={true}
                                    onTouchTap={() => this.setState({ openAddClientContactDialog: true })}>
                                    <ContentAdd />
                                </FloatingActionButton>
                            }
                            <br></br>
                            <Toggle
                                onToggle={(e, checked) =>
                                    this.setState({ active: checked }, () => this.getClientContacts(this.state.clientId, this.state.active))
                                }
                                style={{ width: 300, position: "relative", float: "right" }}
                                defaultToggled={this.state.active}
                                label={strings.Active}
                            />
                            <br></br>
                            <TableActionBar
                                rowSelectionCount={this.state.selectedClientContacts.length}
                                singleSelectedMessage={strings.Contact_Selected}
                                multipleSelectedMessage={strings.x_Contact_Selected}
                                title={strings.Contacts}
                                onSearch={searchText => this.setState({ searchText, offset: 0 })}
                                reloadTable={this.reloadClientContactTable}
                                searchText={""}
                                onDeleteClick={() => AppStateStore.setConfirmDialogContent({
                                    content: strings.Confirm_delete_contact,
                                    confirm: () => this.handleDelete()
                                })
                                }
                                readonly={false}
                            />
                            <ClientContactTable
                                readonly={this.props.readonly}
                                clientContacts={viewableContacts}
                                selectedClientContacts={this.state.selectedClientContacts}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[20, 50, 100]}
                                total={filteredContacts.length}
                                handleSelect={selectedClientContacts => this.setState({ selectedClientContacts })}
                                handleUpdate={selectedContactForEdit => this.setState({ openEditClientContactDrawer: true, selectedContactForEdit })}
                                onPageClick={offset => this.setState({ offset, selectedClientContacts: [] })}
                                onLimitChange={limit => this.setState({ limit, offset: 0, selectedClientContacts: [] })}
                            />
                        </div>
                    }
                </div>
                {this.state.openAddClientContactDialog &&
                    <AddClientContactDialog
                        clientId={this.state.clientId}
                        handleAdd={clientContact => {
                            this.setState({ openAddClientContactDialog: false })
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.addClientContact(clientContact).then(() => {
                                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                                this.getClientContacts(this.state.clientId, this.state.active)
                            })
                        }}
                        handleClose={() => this.setState({ openAddClientContactDialog: false })}
                    />
                }
                <Drawer
                    open={this.state.openEditClientContactDrawer}
                    width={1000}
                    style={{ maxWidth: 1000 }}
                    openSecondary
                    docked={false}
                    overlayStyle={{ zIndex: 1500 }}
                    containerStyle={{
                        zIndex: 1500,
                        opacity: open ? 1 : 0,
                        transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
                    }}
                    onRequestChange={() => this.setState({ openEditClientContactDrawer: false, selectedContactForEdit: undefined })}
                >
                    {this.state.selectedContactForEdit &&
                        <EditClientContactForm
                            readonly={this.props.readonly}
                            selectedContactForEdit={this.state.selectedContactForEdit}
                            handleUpdateClientContact={this.handleUpdateClientContact}
                            closeDrawer={() => this.setState({ openEditClientContactDrawer: false, selectedContactForEdit: undefined })}
                        />
                    }
                </Drawer>
            </div>
        )
    }
}